// extracted by mini-css-extract-plugin
export var deleteButton = "shopping-list-item-module--delete-button--da8c0";
export var deleteButtonText = "shopping-list-item-module--delete-button-text--9191e";
export var detailsButton = "shopping-list-item-module--details-button--12f8b";
export var dot = "shopping-list-item-module--dot--5a6d0";
export var item = "shopping-list-item-module--item--e92a2";
export var itemActions = "shopping-list-item-module--item-actions--8b33a";
export var itemHeader = "shopping-list-item-module--item-header--37955";
export var listIcon = "shopping-list-item-module--list-icon--63266";